"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("../Button/Button"));
const usePrevious_1 = __importDefault(require("../../hooks/usePrevious"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const ButtonGroupConstants_1 = require("./ButtonGroupConstants");
const ButtonWrapper_1 = require("./ButtonWrapper");
const constants_1 = require("../../constants");
const ButtonConstants_1 = require("../Button/ButtonConstants");
require("./ButtonGroup.scss");
const ButtonGroup = (0, react_1.forwardRef)(({ className, 
// Backward compatibility for props naming
componentClassName, options, name = "", disabled = false, value = "", onSelect, size = constants_1.BASE_SIZES.SMALL, kind = ButtonConstants_1.ButtonType.SECONDARY, groupAriaLabel = "", tooltipPosition, tooltipHideDelay, tooltipShowDelay, tooltipContainerSelector, tooltipMoveBy }, ref) => {
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, componentClassName]);
    const inputRef = (0, react_1.useRef)();
    const [valueState, setValueState] = (0, react_1.useState)(value);
    const prevValue = (0, usePrevious_1.default)(value);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, inputRef] });
    const onClick = (0, react_1.useCallback)((option) => {
        const isDisabled = disabled || option.disabled;
        if (!isDisabled) {
            setValueState(option.value);
            if (onSelect) {
                onSelect(option.value, name);
            }
        }
    }, [onSelect, disabled, name]);
    const selectedOption = (0, react_1.useMemo)(() => {
        return options.find(option => option.value === valueState);
    }, [options, valueState]);
    const Buttons = (0, react_1.useMemo)(() => {
        return options.map((option, index) => {
            const isSelected = option.value === valueState;
            return ((0, jsx_runtime_1.jsx)(ButtonWrapper_1.ButtonWrapper, Object.assign({ size: size, onClick: () => onClick(option), rightIcon: option.icon, leftIcon: option.leftIcon, active: isSelected, rightFlat: index !== options.length - 1, leftFlat: index !== 0, kind: Button_1.default.kinds.TERTIARY, preventClickAnimation: true, ariaLabel: option.ariaLabel, tooltipContent: option.tooltipContent, tooltipPosition: tooltipPosition, tooltipHideDelay: tooltipHideDelay, tooltipShowDelay: tooltipShowDelay, tooltipContainerSelector: tooltipContainerSelector, tooltipMoveBy: tooltipMoveBy, className: (0, classnames_1.default)(`${ButtonGroupConstants_1.baseClassName}__option-text`, {
                    selected: isSelected,
                    disabled,
                    "button-disabled": option.disabled
                }) }, { children: option.text }), option.value));
        });
    }, [
        options,
        disabled,
        onClick,
        size,
        valueState,
        tooltipPosition,
        tooltipHideDelay,
        tooltipShowDelay,
        tooltipContainerSelector,
        tooltipMoveBy
    ]);
    // Effects
    (0, react_1.useEffect)(() => {
        // Update value if changed from props
        if (value !== prevValue && value !== valueState) {
            setValueState(value);
        }
    }, [value, prevValue, valueState, setValueState]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)(ButtonGroupConstants_1.baseClassName, overrideClassName, `${ButtonGroupConstants_1.baseClassName}--kind-${kind}`, { disabled }), ref: mergedRef }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ role: "group", "aria-label": groupAriaLabel, className: (0, classnames_1.default)(`${ButtonGroupConstants_1.baseClassName}__buttons-container`), "aria-disabled": disabled }, { children: Buttons })), selectedOption && selectedOption.subText && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `${ButtonGroupConstants_1.baseClassName}__sub-text-container` }, { children: selectedOption.subText })))] })));
});
ButtonGroup.sizes = Button_1.default.sizes;
ButtonGroup.kinds = Button_1.default.kinds;
exports.default = ButtonGroup;
